module.exports = __webpack_public_path__ + "static/media/icon-trash.50033c26.svg";